"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("./SvgIcon"));
const Refresh = (_a) => {
    var rest = __rest(_a, []);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ "data-icon": "refresh", viewBox: "0 0 17 17", fill: "none" }, rest),
        react_1.default.createElement("path", { d: "M6.03125 10.222H1.34375V14.909M15.2712 11.1381C14.7747 12.5889 13.8133 13.8353 12.536 14.6839C11.2587 15.5325 9.73708 15.9359 8.20711 15.8315C6.67714 15.7271 5.2244 15.1207 4.07429 14.1064C2.92417 13.0922 2.14098 11.7267 1.84623 10.222M11 6.47345H15.6875V1.78643M1.72876 5.55721C2.22525 4.10642 3.18672 2.86004 4.46398 2.01143C5.74125 1.16281 7.26291 0.759417 8.79288 0.863825C10.3228 0.968234 11.7756 1.57461 12.9257 2.58887C14.0758 3.60314 14.859 4.96858 15.1538 6.47336", stroke: "#0085FF", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = Refresh;
//# sourceMappingURL=Refresh.js.map